import React from 'react';

function HomePage({ setCurrentView }) {
    const features = [
        {
            title: 'Пошук матеріалів',
            description: 'Знайдіть потрібні матеріали за типом, властивостями, застосуванням або створіть складні фільтри для точного підбору',
            view: 'advancedSearch'
        },
        {
            title: 'Управління даними',
            description: 'Додавайте, редагуйте та видаляйте записи у базі даних. Керуйте матеріалами, елементами, властивостями та застосуваннями',
            view: 'entityManager'
        }
    ];

    return (
        <div className="home">
            <h2>Ласкаво просимо!</h2>
            <p className="home-description">
                Система для інтелектуального пошуку та аналізу властивостей матеріалів
            </p>
            
            <div className="features">
                {features.map((feature, index) => (
                    <div 
                        key={index} 
                        className="feature-card"
                        onClick={() => setCurrentView(feature.view)}
                    >
                        <h3>{feature.title}</h3>
                        <p>{feature.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default HomePage;
